import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  select: {
    '& .MuiSelect-select:focus': {
      backgroundColor: 'initial',
    },
  },
}));
